import { render, staticRenderFns } from "./AddImgReview.vue?vue&type=template&id=aeddedca"
import script from "./AddImgReview.vue?vue&type=script&lang=js"
export * from "./AddImgReview.vue?vue&type=script&lang=js"
import style0 from "./AddImgReview.vue?vue&type=style&index=0&id=aeddedca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports